type CarouselMoveListeners = {
    [key: string] : (activeElements: HTMLElement[], index: number) => void;
}

const carouselMoveListeners : CarouselMoveListeners = {
    logInfo: (activeElements: HTMLElement[], index: number) => {
        console.log("active elements:", activeElements);
        console.log("index:", index);
    }
}

export default carouselMoveListeners;